import component from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/shared/lni-janitorial-job-plan-table/lni-janitorial-job-plan-table.component.vue';
import module from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/shared/lni-janitorial-job-plan-table/lni-janitorial-job-plan-table.module.js';

export default {
    component,
    module,
};